import type { SiteApi } from "@/lib/siteApi";

// The website whose dashboard is open (one at a time). The copied dashboard screens import plain functions
// (actions.ts) and links ("/admin/…"), as they did on the website; these say which website and where in the hub.

let api: SiteApi | undefined;
let base = "/";
let siteUrl = "";

export function openSite(next: SiteApi, basePath: string, url: string) {
  api = next;
  base = basePath;
  siteUrl = url.replace(/\/+$/, "");
}

/** A page of the website itself ("/blog/x") at its own address, for "view on the website" links. */
export const siteHref = (path: string) => (path.startsWith("/") ? `${siteUrl}${path}` : path);

export function site(): SiteApi {
  if (!api) throw new Error("No website is open.");
  return api;
}

/** A dashboard address from the website ("/admin/blog/x") as a hub address ("/sites/tasma/blog/x"). */
export const hubPath = (href: string) => (href === "/admin" || href.startsWith("/admin/") || href.startsWith("/admin?") ? `${base}${href.slice("/admin".length)}` : href);

/** The other way round, for screens that compare the current address with "/admin/…". */
export const adminPath = (pathname: string) => (pathname === base || pathname.startsWith(`${base}/`) ? `/admin${pathname.slice(base.length)}` : pathname);

/** Lists and editors reload their data after a change (the website's router.refresh()). */
export const refreshEvent = "tasma:refresh";
export const refresh = () => window.dispatchEvent(new Event(refreshEvent));
